/**
 * Defines default value for rows per page.
 */
export const defaultRowsPerPage = 20;
/**
 * Defines default rows per page options.
 */
export const defaultRowsPerPageOptions = [10, 20, 50, 100];
